import { FC } from "react";

type HeartIconProps = {
  stroke?: string;
  width?: number;
  height?: number;
  isActive?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const HeartIcon: FC<HeartIconProps> = ({
  stroke = "#232E45",
  width = 26,
  height = 26,
  isActive,
  ...rest
}) => <svg width={width} height={height} {...rest} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.0003 22.2084C13.0003 22.2084 2.16699 15.7084 2.16699 9.41906C2.16699 6.31118 4.44769 3.79175 7.58366 3.79175C9.20866 3.79175 10.8337 4.33341 13.0003 6.50008C15.167 4.33341 16.792 3.79175 18.417 3.79175C21.5529 3.79175 23.8337 6.31118 23.8337 9.41906C23.8337 15.7084 13.0003 22.2084 13.0003 22.2084Z"
      stroke={isActive ? "#EC5B5B" : stroke} strokeWidth="2" strokeLinejoin="round" fill={isActive ? "#EC5B5B" : "none"} />
  </svg>